module.exports = __webpack_public_path__ + "img/0aa7672.jpg";